import { useAuthRestApi } from '../common';
import { IListingRequest, IListingRequestApi, IListingRequestSummary } from '@vivli/features/listing-request/infrastructure/interface';
import { Observable } from 'rxjs';
import { ListingRequestStatusEnum } from '@vivli/features/listing-request/infrastructure/enum';

export const useListingRequestApi = (): IListingRequestApi => {
    const { handleGet, handlePut, handleDelete } = useAuthRestApi();
    const getListingRequest = (listingRequestId: string): Observable<IListingRequest> => {
        return handleGet<IListingRequest>(`/listingRequest/${listingRequestId}`);
    };

    const getAllListingRequests = (): Observable<IListingRequest[]> => {
        return handleGet<IListingRequest[]>(`/listingRequest/list`);
    };

    const getAllListingRequestSummaries = (): Observable<IListingRequestSummary[]> => {
        return handleGet<IListingRequestSummary[]>(`/listingRequest/summaries`);
    };

    const getListingRequestByStatus = (type: ListingRequestStatusEnum): Observable<IListingRequest[]> => {
        return handleGet<IListingRequest[]>(`/listingRequest/statuses/${type}`);
    };

    const upsertListingRequest = (listingRequest: IListingRequest): Observable<IListingRequest> => {
        const dataset = listingRequest.datasets[0];
        return handlePut<IListingRequest>(`/listingRequest/save`, { listingRequest, dataset });
    };

    const updateListingRequestStatus = (listingRequest: IListingRequest, status: ListingRequestStatusEnum): Observable<IListingRequest> => {
        const trimmedStatus = status.replace(/\s/g, '');
        const dataset = listingRequest.datasets[0];
        return handlePut<IListingRequest>(`/listingRequest/changestatus/${listingRequest.id}/${trimmedStatus}`, {
            listingRequest,
            dataset,
            status: trimmedStatus
        });
    };

    const deleteListingRequest = (listingRequestId: string): Observable<void> => {
        return handleDelete<void>(`/listingRequest/${listingRequestId}`);
    };

    return {
        getListingRequest,
        getAllListingRequests,
        getAllListingRequestSummaries,
        getListingRequestByStatus,
        upsertListingRequest,
        updateListingRequestStatus,
        deleteListingRequest
    };
};
